import app from "flarum/forum/app";
import QueryModal from "../components/QueryModal";
export class PurchaseHelper {
  constructor(storeItem) {
    this.storeItem = storeItem;
  }
  static async get(provider) {
    return new PurchaseHelper(await app.store.find("store-item", {
      type: provider
    }));
  }
  filter(predicate) {
    this.storeItem = this.storeItem.filter(predicate);
    return this;
  }
  filterWithData(predicate) {
    this.storeItem = this.storeItem.filter(d => predicate(d.attribute("data")));
    return this;
  }
  filterAvailable() {
    return this.filter(d => {
      return !d.unavailable() && d.rest_cnt() > 0;
    });
  }
  sort(predicate) {
    this.storeItem.sort(predicate);
    return this;
  }
  query() {
    return new Promise((resolve, reject) => {
      if (!this.storeItem.length) return resolve(this);
      const items = this.storeItem;
      this.storeItem = [];
      app.modal.show(QueryModal, {
        items,
        on_submit: selected => {
          this.storeItem = [selected];
        },
        on_close: () => {
          resolve(this);
        }
      }, true);
    });
  }
  hasItem() {
    return this.storeItem.length > 0;
  }
  async purchase() {
    if (!this.storeItem.length) {
      throw new Error("no_item_to_purchase");
    }
    return await app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/store-item/' + this.storeItem[0].id() + '/purchase'
    });
  }
}
flarum.reg.add('xypp-store', 'forum/helper/PurchaseHelper', { PurchaseHelper: PurchaseHelper, });